'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_CuisinesPage$State(msgState) {
  this.ZJ = null;
  this.ZJ = msgState;
}
export { $c_Lmealorama_pages_CuisinesPage$State as $c_Lmealorama_pages_CuisinesPage$State };
$p = $c_Lmealorama_pages_CuisinesPage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_CuisinesPage$State;
/** @constructor */
function $h_Lmealorama_pages_CuisinesPage$State() {
}
export { $h_Lmealorama_pages_CuisinesPage$State as $h_Lmealorama_pages_CuisinesPage$State };
$h_Lmealorama_pages_CuisinesPage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 382765188, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_CuisinesPage$State)) {
    var x = this.ZJ;
    var x$2 = x$0.ZJ;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.ZJ;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_pages_CuisinesPage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kn)));
}
export { $isArrayOf_Lmealorama_pages_CuisinesPage$State as $isArrayOf_Lmealorama_pages_CuisinesPage$State };
var $d_Lmealorama_pages_CuisinesPage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_CuisinesPage$State, "mealorama.pages.CuisinesPage$State", ({
  kn: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_CuisinesPage$State as $d_Lmealorama_pages_CuisinesPage$State };
//# sourceMappingURL=mealorama.pages.-Cuisines-Page$-State.js.map
